module.exports = __webpack_public_path__ + "static/media/download.4cabc6d4.svg";